<div class="flex flex-col gap-1">
  <tui-textfield
    [ngClass]="$fieldClass()"
    tuiTextfieldSize="m"
    tuiTextfieldAppearance="textfield"
    [tuiTextfieldCleaner]="true"
    [title]="$label()"
  >
    @if ($showLabel()) {
      <label tuiLabel [for]="fieldId">{{ $label() }}</label>
    }
    <textarea
      tuiTextarea
      [id]="fieldId"
      [min]="1"
      [max]="4"
      [placeholder]="$placeholder()"
      [ngModel]="$text()"
      (ngModelChange)="onTextChange($event)"
      (blur)="onApply()"
      (keydown.control.enter)="onApply()"
    ></textarea>
  </tui-textfield>

  @if ($showCount() || $hint()) {
    <div class="flex items-center justify-center gap-1">
      @if ($showCount()) {
        <span class="typo-body-s text-(--tui-text-secondary)">
          {{
            'mass_filter_input.values_count' | translate: { count: $count() }
          }}
        </span>
      }

      @if ($hint(); as hint) {
        <tui-icon
          class="shrink-0 text-base"
          [icon]="hint.negative ? '@tui.circle-alert' : '@tui.circle-help'"
          [ngClass]="
            hint.negative
              ? 'text-(--tui-status-negative)'
              : 'text-(--tui-text-tertiary)'
          "
          [tuiHint]="hint.key | translate: hint.params"
          [tuiHintDescribe]="fieldId"
          tuiHintDirection="bottom"
        />
      }
    </div>
  }
</div>
